import { render, staticRenderFns } from "./DashboardBuilderModal.vue?vue&type=template&id=6afd39d6&scoped=true"
import script from "./DashboardBuilderModal.vue?vue&type=script&lang=js"
export * from "./DashboardBuilderModal.vue?vue&type=script&lang=js"
import style0 from "./DashboardBuilderModal.vue?vue&type=style&index=0&id=6afd39d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afd39d6",
  null
  
)

export default component.exports